import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavItem, NavEntryPoint } from '@retailer-platform/dashboard/routing'
import { storeConfigurationRouter } from './routing/storeConfigurationRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { storeConfigurationAccessControl } from './access-control/storeConfigurationAccess.configuration'
import { Permission } from './access-control/permissions'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'store-configuration',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'store-configuration-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    scoped: [storeConfigurationRouter],
  },
  navigationEntries: [
    {
      attachTo: NavItem.Storefront,
      attachToV2: NavEntryPoint.UserMenuSettings,
      subNavItems: [
        {
          type: 'item',
          llmDescription:
            'View and manage store configuration (storefront configuration settings) drafts',
          labelId: 'storeConfigurationDomain.title',
          route: 'store-configuration-drafts',
          accessControl: storeConfigurationAccessControl,
          id: 'store-configuration-drafts',
          positionNavV2: 3,
          inToolPermissions: [
            {
              slug: Permission.StoreConfiguration,
              permissionLabelId: 'permissionAccordion.permissions.' + Permission.StoreConfiguration,
            },
          ],
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
